export const BASKET_STORAGE_KEY = 'basket-id';
export const BASKET_TIMESTAMP_KEY = 'basket-timestamp';
export const BASKET_QUERY_KEY = 'basket';
